import { ComponentProps } from "../registry";
import { useBound } from "../helpers";
import { BoundValue } from "../../types";

export function Video({ fields, scope }: ComponentProps) {
  const url = useBound<string>(fields.url as BoundValue, scope);
  if (!url) return null;
  return <video className="a2-video" src={url} controls />;
}
